import { Injectable } from '@angular/core';
import { Observable, firstValueFrom, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

import { MessageService } from '../services/message.service';

@Injectable({
  providedIn: 'root',
})

export class AuthService {
  endpoint: string = '/api';
  headers = new HttpHeaders().set('Content-Type', 'application/json');
  
  constructor(private http: HttpClient, public router: Router, private messageService: MessageService) {}
  
  login(user: {}) {
    return this.http
      .post<any>(`${this.endpoint}/media/login`, user)
      .subscribe((res: any) => {
        localStorage.setItem('media_access_token', res.token);
        
        this.getUserProfile().subscribe(user => {
          localStorage.setItem('media_user', JSON.stringify(user));

          this.messageService.connect()

          this.router.navigate(['/']);
        })
      }, (error: any) => {
        alert(error.error)
      })
  }
  
  getUser() {
    return JSON.parse(`${localStorage.getItem('media_user')}`);
  }

  getToken() {
    return localStorage.getItem('media_access_token');
  }
  
  isAdmin(): boolean {
    if(this.getUser().type == 'administrator') {
       return true
    }
    else {
      return false
    }
  }

  get isLoggedIn(): boolean {
    let authToken = localStorage.getItem('media_access_token');
    return authToken !== null ? true : false;
  }
  
  logout() {    
    this.http.get(`${this.endpoint}/media/logout`).subscribe(res => {
      localStorage.removeItem('media_access_token');
      localStorage.removeItem('media_user');
  
      this.router.navigate(['/login']);
    })
  }

  // User profile
  getUserProfile(): Observable<any> {
    let api = `${this.endpoint}/media/current`;
    
    return this.http.get(api, { headers: this.headers }).pipe(
      map((res) => {
        return res || {};
      }),
      catchError(this.handleError)
    );
  }
  
  // Error
  handleError(error: HttpErrorResponse) {
    let msg = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      msg = error.error.message;
    } else {
      // server-side error
      msg = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(msg);
  }

  public organizations(email: string): Observable<any> {
    return this.http.post(`/media/media/organizations`, { email: email });
  }

  signup(data: {}) {
    return this.http
      .post<any>(`${this.endpoint}/media/signup`, data)
      .subscribe((res: any) => {
        localStorage.setItem('media_access_token', res.token);
        
        this.getUserProfile().subscribe(user => {
          localStorage.setItem('media_user', JSON.stringify(user));

          this.router.navigate(['/']);
        })
      }, (error: any) => {
        alert(error.error)
      })
  }
}